export const STATEMENT_PRINT_ROOT = 'xsib-statement-print'

export const STATEMENT_PRINT_CSS = `
  .${STATEMENT_PRINT_ROOT} { display: none; }
  @media print {
    @page { size: A4; margin: 12mm; }
    html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    body > *:not(.${STATEMENT_PRINT_ROOT}) { display: none !important; }
    .${STATEMENT_PRINT_ROOT} { display: block; }
    .${STATEMENT_PRINT_ROOT} thead { display: table-header-group; }
    .${STATEMENT_PRINT_ROOT} tr { break-inside: avoid; }
  }
`

const LOGO_WAIT_MS = 3000

export async function statementImagesSettled(): Promise<void> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(`.${STATEMENT_PRINT_ROOT} img`))
  const decodes = images.map((image) => image.decode().catch(() => undefined))
  const timeout = new Promise<void>((resolve) => setTimeout(resolve, LOGO_WAIT_MS))
  await Promise.race([Promise.all(decodes).then(() => undefined), timeout])
}
